exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".vm--overlay[data-v-661e60fc]{background:#000;opacity:.7}", ""]);

// exports
